import { motion } from "framer-motion";

export const Nav = () => (
  <motion.nav
    data-testid="main-nav"
    initial={{ y: -40, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
    className="absolute top-0 left-0 right-0 z-40 flex items-center justify-between px-6 lg:px-14 py-5 border-b border-white/[0.06] bg-black/60 backdrop-blur-md"
  >
    <div data-testid="nav-wordmark" className="flex items-center gap-3">
      <span className="w-2 h-2 bg-[#8A2BE2] rotate-45" />
      <span className="font-display text-2xl tracking-[0.3em] text-white">INSSUX</span>
    </div>

    <div data-testid="nav-status-label" className="hidden md:flex items-center gap-3">
      <span className="status-dot w-2 h-2 rounded-full bg-[#FFD166]" />
      <span className="font-mono-file text-[11px] tracking-[0.25em] text-white/60">
        JACK IS IN THE CASE ROOM
      </span>
    </div>

    <div className="flex items-center gap-6">
      <span className="hidden sm:block font-mono-file text-[11px] tracking-[0.25em] text-[#FFD166]/70">
        FILE / 001
      </span>
      <button
        data-testid="nav-ask-jack-btn"
        onClick={() => window.AIWidget?.ask()}
        className="font-display text-xs tracking-[0.3em] text-[#FFD166] border border-[#FFD166]/50 px-5 py-2.5 hover:bg-[#FFD166]/10 hover:border-[#FFD166] transition-colors duration-300"
      >
        ASK JACK
      </button>
    </div>
  </motion.nav>
);

export default Nav;
